import { render, staticRenderFns } from "./CalenderDays.vue?vue&type=template&id=65dae91d&scoped=true&"
import script from "./CalenderDays.vue?vue&type=script&lang=js&"
export * from "./CalenderDays.vue?vue&type=script&lang=js&"
import style0 from "./CalenderDays.vue?vue&type=style&index=0&id=65dae91d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dae91d",
  null
  
)

/* custom blocks */
import block0 from "./CalenderDays.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CalenderDays.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports